import { render, staticRenderFns } from "./ServiceVisit.vue?vue&type=template&id=398a550b&scoped=true"
import script from "./ServiceVisit.vue?vue&type=script&lang=ts"
export * from "./ServiceVisit.vue?vue&type=script&lang=ts"
import style0 from "./ServiceVisit.vue?vue&type=style&index=0&id=398a550b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398a550b",
  null
  
)

export default component.exports